import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useT } from "@/i18n";
import { APP } from "@/config";

export const Footer = () => {
  const { t } = useT();
  return (
    <footer className="border-t border-border bg-card/40">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="mt-3 max-w-xs text-sm text-muted-foreground">{APP.tagline}</p>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold">{t("footer.product")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/pricing" className="hover:text-foreground">{t("nav.pricing")}</Link></li>
              <li><a href="/#features" className="hover:text-foreground">{t("nav.features")}</a></li>
              <li><a href="/#faq" className="hover:text-foreground">{t("nav.faq")}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold">{t("footer.legal")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="hover:text-foreground">{t("legal.privacy")}</Link></li>
              <li><Link to="/terms" className="hover:text-foreground">{t("legal.terms")}</Link></li>
              <li><Link to="/cookies" className="hover:text-foreground">{t("legal.cookies")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold">{t("footer.company")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {APP.supportEmailActive && APP.supportEmail ? (
                <li><a href={`mailto:${APP.supportEmail}`} className="hover:text-foreground" data-testid="support-email-link">{APP.supportEmail}</a></li>
              ) : (
                <li data-testid="support-email-pending">{t("footer.supportPending")}</li>
              )}
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-border pt-6 text-sm text-muted-foreground">
          © {new Date().getFullYear()} {APP.name}. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};
